// extracted by mini-css-extract-plugin
export default {"noTemplates":"templates-list-section_noTemplates__Iq7Zg"};